define('view/controller/booking/datetime/DateInlinePickerLabelView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#date_inline_label_view',
        modelEvents: {
            'change': 'render'
        },
        _minDate: null,
        _maxDate: null,
        _dates: [],
        _weekMode: false,

        initialize: function () {
            this._dates = this.getOption('dates');
        },

        setSelectedDates: function (dates) {
            this._dates = dates;
            this._weekMode = (dates.length > 1);

            if (!this.isDestroyed) {
                this.render();
            }
        },

        serializeData: function () {
            var dates = _.map(this._dates, Date.parseMysqlDate);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            return _.extend(LayoutView.prototype.serializeData.apply(this), {
                'dates': this._dates,
                'week_mode': (this._dates.length > 1),
                'from_date': minDate,
                'to_date': maxDate
            });
        }

    });

});
